export class GenericData<T> {
  idPere: string;
  listFils: T[];

  constructor() {
    this.idPere = '';
    this.listFils = [];
  }
}

export class LogPerf {
  public pageUrl: string;
  public apiUrl: string;
  public startTime: Date;
  public endTime: Date;
  public totSeconds: number;
  public totMinutes: number;
  public totHours: number;
  constructor(page: string, api: string, start: Date) {
    this.pageUrl = page;
    this.apiUrl = api;
    this.startTime = start;
  }
}

export enum WSAppSource {
  NONE,
  EXTRANET,
  PUBLIC
}
export enum WSUserRole {
  NONE,
  RH,
  APPRENANT,
  APPRENANT_PLUS
}
export enum WSRegMode {
  NONE,
  INFO,
  PREINSCRIPTION,
  PREINSCRIPTION_CYCLE
}
